import {Component, OnInit, Directive, Input, Output, EventEmitter} from '@angular/core';
import {pluginVersion, Init} from 'directpay-ipg-js';
import {
  IDirectPayIpgConfig,
  DirectPayIpgConfig,
  DirectPayIpgBtnColours,
  DirectPayIpgBtnTypes
} from './direct-pay-ipg.config'
import {DirectPayIpgService} from "./direct-pay-ipg.service";

@Component({
  selector: 'direct-pay-ipg',
  templateUrl: './direct-pay-ipg.component.html',
  styleUrls: ['./direct-pay-ipg.component.css']
})

export class DirectPayIpgComponent implements OnInit {

  @Input() config: IDirectPayIpgConfig = new DirectPayIpgConfig();
  private defaultConfig: IDirectPayIpgConfig = {
    size: 200,
    type: DirectPayIpgBtnTypes.flat,
    colour: DirectPayIpgBtnColours.gray
  };
  public directPayIpgBtnColours = DirectPayIpgBtnColours;
  public directPayIpgBtnTypes = DirectPayIpgBtnTypes;
  public isLoading = false;

  constructor(private _directPayIpgService: DirectPayIpgService) {
    console.log('[DirectPayIpgComponent][constructor][DirectPayIpgService]', _directPayIpgService)
  }

  ngOnInit(): void {
    this.setupConfig();
  }

  private setupConfig(): void {
    for (const option in this.defaultConfig) {
      if (typeof this.config[option] === 'boolean') {
        if (this.config[option] != null) {
          continue;
        }
        this.config[option] = this._directPayIpgService.loadingConfig[option] != null ? this._directPayIpgService.loadingConfig[option] : this.defaultConfig[option];
      } else {
        if (this.config[option] != null) {
          continue;
        }
        this.config[option] = this._directPayIpgService.loadingConfig[option] != null ? this._directPayIpgService.loadingConfig[option] : this.defaultConfig[option];
      }
    }
  }

  @Input() PaymentRequest: {
    stage: string;
    dataString: string;
    signature: object;
  } | undefined;
  @Output() onSuccess: EventEmitter<any> = new EventEmitter<any>();
  @Output() onError: EventEmitter<any> = new EventEmitter<any>();

  public pay() {
    console.info('[pay-with-directPay][req-date]', this.PaymentRequest)
    this.isLoading = true;
    new Init({
      signature: this.PaymentRequest?.signature,
      dataString: this.PaymentRequest?.dataString,
      stage: this.PaymentRequest?.stage
    }).doInAppCheckout().then((data) => {
      console.info("[pay-with-directPay][res-success]", JSON.stringify(data));
      this.isLoading = false;
      this.onSuccess.emit(data)
    }).catch(error => {
      console.error("[pay-with-directPay][res-error]", JSON.stringify(error));
      this.isLoading = false;
      this.onError.emit(error)
    });
  }


}
